import React from "react";
import {
  Row,
  Col,
  Form,
  InputGroup,
  Button,
  Alert,
  Spinner,
} from "react-bootstrap";
import { FaIdCard, FaBell } from "react-icons/fa";

const AlertsTab = ({
  notificationData,
  notificationStatus,
  handleNotificationSubmit,
  handleNotificationChange,
}) => {
  return (
    <>
      <div className="pane-header">
        <h2 className="pane-title">התרעות מערכת</h2>
        <p className="pane-subtitle">ניהול התרעות המערכת</p>
      </div>
      <div className="notifications-container">
        <Form onSubmit={handleNotificationSubmit}>
          <Row className="mb-3">
            <Col md={6}>
              <Form.Group>
                <Form.Label>מזהה משתמש</Form.Label>
                <InputGroup>
                  <InputGroup.Text>
                    <FaIdCard />
                  </InputGroup.Text>
                  <Form.Control
                    type="text"
                    name="userId"
                    value={notificationData.userId}
                    onChange={handleNotificationChange}
                    placeholder="הזן מזהה משתמש"
                    required
                  />
                </InputGroup>
              </Form.Group>
            </Col>
            <Col md={6}>
              <Form.Group>
                <Form.Label>סוג הודעה</Form.Label>
                <InputGroup>
                  <InputGroup.Text>
                    <FaBell />
                  </InputGroup.Text>
                  <Form.Control
                    type="text"
                    name="messageType"
                    value={notificationData.messageType}
                    onChange={handleNotificationChange}
                    placeholder="הזן סוג הודעה"
                    required
                  />
                </InputGroup>
              </Form.Group>
            </Col>
          </Row>
          <Button
            variant="primary"
            type="submit"
            disabled={notificationStatus.loading}
          >
            {notificationStatus.loading ? (
              <>
                <Spinner
                  as="span"
                  animation="border"
                  size="sm"
                  role="status"
                  aria-hidden="true"
                />{" "}
                שולח...
              </>
            ) : (
              "שלח התראה"
            )}
          </Button>
        </Form>

        {notificationStatus.success && (
          <Alert variant="success" className="mt-3">
            {notificationStatus.success}
          </Alert>
        )}

        {notificationStatus.error && (
          <Alert variant="danger" className="mt-3">
            {notificationStatus.error}
          </Alert>
        )}
      </div>
    </>
  );
};

export default AlertsTab;
